import React from 'react';
import { FeatureContainer } from '../../components/molecules/Containers/FeatureContainer';
import { ButtonWithText } from '../../components/atoms/Buttons/ButtonWithText';
import useGoToPage from '../../hooks/useGoToPage';
import pages from '../../routes/pages';
import { resetQuiz } from '../../store/actions/quiz.action';
import { useDispatch, useSelector } from 'react-redux';
import { QuizQuestion } from '../../types/quiz/quiz.def';
import { AppState } from '../../store/reducers';
import useStyle from './quizSingle.style';

export interface FinDeQuizProps {
  last: () => void;
  questions: QuizQuestion[];
  loading: boolean;
}

const FinDeQuiz = ({ last, questions, loading }: FinDeQuizProps) => {
  const classes = useStyle();
  const goToQuizList = useGoToPage(pages.QUIZ_PAGE.path);
  const quizAnswers = useSelector((state: AppState) => state.quiz.reponses);
  const dispatch = useDispatch();
  const onClick = () => {
    dispatch(resetQuiz());
    goToQuizList();
  };
  const findUserReponse = questionId => {
    const quizAnswer = quizAnswers.find(
      answer => answer.question.id === questionId.toString()
    );
    const response = questions.find(
      question => question.id === quizAnswer.question.id
    );
    return response[`reponse${quizAnswer.reponse.reponseNumber}`];
  };
  return (
    <FeatureContainer>
      <h2 className={classes.finDeQuizTitle}>
        Êtes-vous sûr(e) de vouloir valider ces réponses ?
      </h2>
      <div>
        {questions.map(question => (
          <div key={question.id} className={classes.finDeQuizAnswerContainer}>
            <h2>{question.name}</h2>
            <p>{findUserReponse(question.id)}</p>
          </div>
        ))}
      </div>
      <div style={{ display: 'flex', margin: 'auto', gap: '20px' }}>
        <ButtonWithText
          content={'Non, je veux revenir aux quiz'}
          onClick={onClick}
          variant="text"
        />
        <ButtonWithText
          content={'Oui je suis sûr(e) !'}
          onClick={last}
          variant="primaryGreen"
          loading={loading}
        />
      </div>
    </FeatureContainer>
  );
};
export default FinDeQuiz;
